export function createSimpleReducer<S>(defaultState: S) {
  return (state: S = defaultState) => state;
}
